import { Form } from "antd";
import { getUdfComponent } from "common/utils";
import { useUserType } from "features/auth";
import { useFetchAllCreditorUdfCustomFieldsQuery } from "features/userDefinedFields/agencyPortal/creditorUserDefinedFieldsAPI";

export default function CreditorCustomFields() {
  const { isAgencyUserType } = useUserType();

  const { data: creditorCustomFields } = useFetchAllCreditorUdfCustomFieldsQuery(
    {},
    { skip: !isAgencyUserType },
  );

  return (creditorCustomFields ?? []).map((field) => (
    <Form.Item
      key={field.id}
      label={field.name}
      name={["customFields", field.slug]}
      rules={[{ required: field.isRequired }]}
    >
      {getUdfComponent(field)}
    </Form.Item>
  ));
}
